import styled from '@emotion/styled';
import { mediaDesktop } from 'components/core/theme/breakpoints';

export const Logo = styled.div`
  align-self: center;
`;

export const UserName = styled.div`
  align-self: center;
`;

export const AppNavHolder = styled.div`
  grid-area: header;
  display: flex;
  justify-content: start;
  align-self: start;

  ${mediaDesktop} {
    padding-left: 56px;
  }
`;
